import { render, staticRenderFns } from "./Warp10Summary.vue?vue&type=template&id=04d59c36&"
import script from "./Warp10Summary.vue?vue&type=script&lang=ts&"
export * from "./Warp10Summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports